import React, { useEffect, useState } from 'react';
import { fetchContenido } from '../services/api';

function QuienesSomosPage() {
  const [contenido, setContenido] = useState(null);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    fetchContenido('quienes-somos')
      .then(res => setContenido(res.data))
      .catch(() => setContenido(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={st.cargando}>Cargando...</p>;
  if (!contenido) return <p style={st.cargando}>Contenido no disponible.</p>;

  return (
    <div style={st.pagina}>
      <div style={st.card} className="qs-card">
        <h1 style={st.titulo}>{contenido.titulo}</h1>
        <div style={st.separador} />
        <p style={st.texto}>{contenido.contenido}</p>
      </div>
    </div>
  );
}

const st = {
  pagina:    { maxWidth: 860, margin: '40px auto', padding: '0 20px' },
  card:      {
    backgroundColor: '#fff', borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)', padding: '40px 48px',
  },
  titulo:    { fontSize: 28, fontWeight: 700, color: '#1a1a2e', margin: '0 0 12px' },
  separador: { width: 60, height: 4, backgroundColor: '#1a1a2e', borderRadius: 2, marginBottom: 28 },
  texto:     { fontSize: 16, lineHeight: 1.8, color: '#374151', whiteSpace: 'pre-line', margin: 0 },
  cargando:  { textAlign: 'center', marginTop: 60, color: '#888' },
};

export default QuienesSomosPage;
